import * as uuid from 'uuid'

import { earlyRepaymentChargeOptions, productTypeOptions } from 'pages/QuickSearch/Tabs/FurtherInformationTab/FurtherInformationTab.helper'
import { commonUtils } from 'utils'

export const clientDetailsColumns = [
  {
    name: 'item',
    header: 'Item',
    defaultFlex: 1,
    type: 'text',
  },
  {
    name: 'value',
    header: 'Value',
    defaultFlex: 1,
    type: 'text',
  },
]

export const generateClientDetailsDataSource = (userData: any) => {
  const { firstName, lastName, gender, dateOfBirth } = userData
  const age = commonUtils.calculateAge(dateOfBirth)
  return [
    {
      id: uuid.v4(),
      item: 'Name',
      value: `${firstName} ${lastName}`,
    },
    {
      id: uuid.v4(),
      item: 'Sex',
      value: gender,
    },
    {
      id: uuid.v4(),
      item: 'Date of birth',
      value: dateOfBirth,
    },
    {
      id: uuid.v4(),
      item: 'Age',
      value: age,
    },
    {
      id: uuid.v4(),
      item: 'Medical details',
      value: 'No',
    },
  ]
}

export const policyDetailsColumns = [
  {
    name: 'item',
    header: 'Item',
    defaultFlex: 1,
    type: 'text',
  },
  {
    name: 'value',
    header: 'Value',
    defaultFlex: 1,
    type: 'text',
  },
]

export const generatePolicyDetailsDataSource = ({ quickSearchData }: any) => {
  const {
    propertyAndLanding: {
      propertyValue,
      propertyType,
      inheritanceProtection,
      inheritanceProtectPercentage,
      postcode,
      houseNameOrNumber,
      location,
      tenureType,
      leasePeriod,
      // requiredFunding,
      isExLocalAuthorityOrMODProperty,
      maximumPayment,
      paymentAmountOnInitialAdvance,
    },
    furtherInformation: {
      residenceType,
      adviceFee,
      productResearchEnvironment,
      earlyRepaymentCharge,
      interestServicingPercentage,
      interestServicingLevel,
      productType,
    },
  } = quickSearchData

  return [
    {
      id: uuid.v4(),
      item: 'Product Research Environment',
      value: productResearchEnvironment,
    },
    {
      id: uuid.v4(),
      item: 'Early Repayment Charge',
      value: earlyRepaymentCharge?.map((chargeType: string) => earlyRepaymentChargeOptions.find((option) => option.value === chargeType)?.label).join(', '),
    },
    {
      id: uuid.v4(),
      item: 'The House Number or Name of The Property',
      value: houseNameOrNumber,
    },
    {
      id: uuid.v4(),
      item: 'Property value',
      value: `£${commonUtils.formatNumberWithCommas(propertyValue)}`,
    },
    {
      id: uuid.v4(),
      item: 'Property type',
      value: propertyType,
    },
    {
      id: uuid.v4(),
      item: 'Inheritance protection',
      value: inheritanceProtection ? 'Yes' : 'No',
    },
    ...(inheritanceProtection
      ? [
          {
            id: uuid.v4(),
            item: 'Protect (%)',
            value: `${inheritanceProtectPercentage}%`,
          },
        ]
      : []),
    {
      id: uuid.v4(),
      item: 'Postcode',
      value: postcode,
    },
    {
      id: uuid.v4(),
      item: 'Location',
      value: location,
    },
    {
      id: uuid.v4(),
      item: 'Tenure',
      value: tenureType,
    },
    ...(tenureType === 'Leasehold'
      ? [
          {
            id: uuid.v4(),
            item: 'Lease Term (Years)',
            value: leasePeriod,
          },
        ]
      : []),
    {
      id: uuid.v4(),
      item: 'Initial payment amount required',
      value: maximumPayment ? 'Maximum amount' : 'Specified amount',
    },
    ...(!maximumPayment
      ? [
          {
            id: uuid.v4(),
            item: 'Specified amount',
            value: `£${commonUtils.formatNumberWithCommas(paymentAmountOnInitialAdvance)}`,
          },
        ]
      : []),
    {
      id: uuid.v4(),
      item: 'Ex-local authority',
      value: isExLocalAuthorityOrMODProperty ? 'Yes' : 'No',
    },
    {
      id: uuid.v4(),
      item: 'Residence type',
      value: residenceType,
    },
    {
      id: uuid.v4(),
      item: 'Advice Fee',
      value: `£${commonUtils.formatNumberWithCommas(adviceFee)}`,
    },
    {
      id: uuid.v4(),
      item: 'Product type',
      value: productType?.map((type: string) => productTypeOptions.find((option) => option.value === type)?.label).join(', '),
    },

    ...(productType?.includes('interestOnlyServicing')
      ? [
          {
            id: uuid.v4(),
            item: 'Interest servicing level',
            value:
              interestServicingLevel === 'specifiedPercentageOfInterest'
                ? `Specified percentage of interest - ${interestServicingPercentage}%`
                : interestServicingLevel === 'fullInterestAmount'
                ? 'Full interest amount'
                : '',
          },
        ]
      : []),
  ]
}
